import React from 'react';
import Amenities from '../components/Amenities';

const AmenitiesPage = () => {
  return (
    <>
      <Amenities />
    </>
  );
};

export default AmenitiesPage;
